export const Locales = {
    bgBG: 'bg-BG',
    enUS: 'en-US',
}
